import { useGLTF } from '@react-three/drei';
import { useEffect, useRef, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import gsap from 'gsap';
import modelsPos from '/data/modelsPos.json';

export default function Trees() {
    const { nodes } = useGLTF('./models/tree.glb');
    const location = useLocation();

    const groupHome = useRef([]);
    const groupContext = useRef([]);

    const homeTrees = modelsPos.trees.filter(tree => tree.route === '/');
    const contextTrees = modelsPos.trees.filter(tree => tree.route === '/context');

    const rotationParams = useMemo(() => {
        return modelsPos.trees.map((_, index) => ({
            rotationAxis: Math.random() > 0.5 ? 'z' : 'x', 
            duration: 4 + Math.random() * 2, 
            amplitude: 0.05 + Math.random() * 0.06,
            delay: Math.random() * 0.5 
        }));
    }, []);

    useEffect(() => {
        const animateTrees = (treeGroups, forward, delay) => {
            treeGroups.forEach((group, index) => {
                if (group) {
                    gsap.killTweensOf(group.rotation);
                    
                    const treeConfig = modelsPos.trees[index];
                    
                    gsap.to(group.position, {
                        y: forward ? treeConfig.y : -6,
                        duration: 4,
                        delay: delay + index * 0.2,
                        ease: 'sine.inOut',
                    });

                    gsap.to(group.scale, {
                        x: forward ? treeConfig.sx : 0,
                        y: forward ? treeConfig.sy : 0,
                        z: forward ? treeConfig.sz : 0,
                        duration: 4,
                        delay: delay + index * 0.2,
                        ease: 'sine.inOut',
                    });

                    const params = rotationParams[index];
                    gsap.to(group.rotation, {
                        [params.rotationAxis]: params.amplitude,
                        duration: params.duration,
                        repeat: -1,
                        yoyo: true,
                        ease: 'sine.inOut',
                        delay: params.delay
                    });
                }
            });
        };

        if (location.pathname === '/') {
            animateTrees(groupHome.current, true, .3);
            animateTrees(groupContext.current, false, 0);
        } else if (location.pathname === '/context') {
            animateTrees(groupHome.current, true, 0);
            animateTrees(groupContext.current, true, 0);
        }
        else{
            animateTrees(groupHome.current, true, 0);
            animateTrees(groupContext.current, true, 0);  
        }
    }, [location.pathname, rotationParams]);

    return (
        <>
            {homeTrees
                .sort((a, b) => a.index - b.index) 
                .map((tree, index) => (
                    <group
                        key={index}
                        ref={(el) => (groupHome.current[index] = el)}
                        position={[tree.x, -6, tree.z]}
                        scale={[0, 0, 0]}
                    >
                        <mesh
                            geometry={nodes.tree.geometry}
                            receiveShadow
                            onClick={(event) => event.stopPropagation()}
                            onPointerEnter={(event) => event.stopPropagation()}
                        >
                            <meshStandardMaterial color={0x392821} />
                        </mesh>
                    </group>
                ))
            }
            {contextTrees
                .sort((a, b) => a.index - b.index) 
                .map((tree, index) => (
                    <group
                        key={index}
                        ref={(el) => (groupContext.current[index] = el)}
                        position={[tree.x, -6, tree.z]}
                        scale={[0, 0, 0]}
                    >
                        <mesh
                            geometry={nodes.tree.geometry}
                            receiveShadow
                            onClick={(event) => event.stopPropagation()}
                            onPointerEnter={(event) => event.stopPropagation()}
                        >
                            <meshStandardMaterial color={0x392821} />
                        </mesh>
                    </group>
                ))
            }
        </>
    );
}